import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class UsersService {
  constructor(private http: HttpClient) {}

  public GetInfo() {
    let targetUrl = `${environment.api_base}/private/users/get_info`;
    return this.http.get<any>(targetUrl);
  }

  public GetUserInfo(userId) {
    let targetUrl = `${environment.api_base}/private/users/get_info?id=${userId}`;
    return this.http.get<any>(targetUrl);
  }

  public GetActiveCoach() {
    let targetUrl = `${environment.api_base}/private/users/get_active_coach`;
    return this.http.get<any>(targetUrl);
  }

  public GetCoachRating(coach_id) {
    let targetUrl = `${environment.api_base}/private/coaches/get_coach_rating?coach_id=${coach_id}`;
    return this.http.get<any>(targetUrl);
  }

  public SubmitRating(data) {
    let targetUrl = `${environment.api_base}/private/coaches/submit_coach_rating`;
    return this.http.post<any>(targetUrl, data);
  }

  public SubmitReport(data) {
    let targetUrl = `${environment.api_base}/private/users/submit_report`;
    return this.http.post<any>(targetUrl, data);
  }

  public UpdateUser(data) {
    let targetUrl = `${environment.api_base}/private/users/update`;
    return this.http.post<any>(targetUrl, data);
  }
}
